import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { CompanyService } from '../CompanyService';
import { ErrorToast } from '../../../utils/toasters';

interface IGroupOption {
    id: number;
    label: string;
    labelDe?: string;
    position?: number;
}

interface IEditGroupOptionModal {
    show: boolean;
    groupId: number;
    option: IGroupOption | null;
    onHide: () => void;
    onUpdated: (groupId: number, option: IGroupOption) => void;
}

export function EditGroupOptionModal({ show, groupId, option, onHide, onUpdated }: IEditGroupOptionModal) {
    const [form, setForm] = useState({ label: '', labelDe: '' });

    useEffect(() => {
        if (option) {
            setForm({ label: option.label, labelDe: option.labelDe ?? '' });
        }
    }, [option]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = () => {
        if (!option) return;
        const body = {
            label: form.label,
            ...(form.labelDe && { labelDe: form.labelDe }),
        };
        CompanyService.updateGroupOption(groupId, option.id, body)
            .then(data => {
                onUpdated(groupId, data);
                onHide();
            })
            .catch(err => ErrorToast(err));
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Edit option</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label>
                        Label EN <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control name="label" value={form.label} onChange={handleChange} />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Label DE</Form.Label>
                    <Form.Control name="labelDe" value={form.labelDe} onChange={handleChange} />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit} disabled={!form.label}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
